import { Button, Flex } from '@mantine/core';
import { IconNote, IconWand } from '@tabler/icons-react';
import * as React from 'react';

import s from './MobileQuickThoughtsActions.module.scss';

type MobileQuickThoughtsActionsProps = {
  onCreateNote: () => void;
  onCreateInsight: () => void;
  disableNote?: boolean;
  disableInsight?: boolean;
};

const MobileQuickThoughtsActions: React.FC<MobileQuickThoughtsActionsProps> = ({
  onCreateInsight,
  onCreateNote,
  disableInsight,
  disableNote,
}) => {
  return (
    <Flex className={s.root} align="center" justify="center" gap={4}>
      <Button
        className={s.root__button}
        onClick={onCreateNote}
        disabled={disableNote}
        leftSection={<IconNote />}
        variant="light"
        size="xs"
      >
        Cоздать заметку
      </Button>
      <Button
        className={s.root__button}
        onClick={onCreateInsight}
        disabled={disableInsight}
        leftSection={<IconWand />}
        variant="light"
        size="xs"
      >
        Создать инсайт
      </Button>
      <Button
        className={s['root__button-small']}
        onClick={onCreateNote}
        disabled={disableNote}
        leftSection={<IconNote />}
        variant="light"
        size="xs"
      >
        Заметка
      </Button>
      <Button
        className={s['root__button-small']}
        onClick={onCreateInsight}
        disabled={disableInsight}
        leftSection={<IconWand />}
        variant="light"
        size="xs"
      >
        Инсайт
      </Button>
    </Flex>
  );
};

export default React.memo(MobileQuickThoughtsActions);
